<template>
  <legal-page :content="content" />
</template>

<script>
import LegalPage from '../LegalPage.vue';
import rawMd from './privacy.md';

export default {
  name: 'PrivacyPage',
  components: { LegalPage },
  data() {
    return { content: rawMd };
  }
};
</script>
